import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import CardCarousel from '../../../../components/CardCarousel';

import './style.scss';

const FeedbackSection = () => {
  return (
    <section className="l-feedback">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
      </Parallax>
      <div className="container">
        <CardCarousel>
          <div className="card">
            <div className="quote">
              “I had hoped we might achieve a lot but I have to say we've achieved more, and I have to say 'we' because
              I feel like I was a part of this process.”
            </div>
            <div className="author">- Stakeholder Feedback on the Framework</div>
          </div>

          <div className="card">
            <div className="quote">“I’m really excited about a modularised application process!”</div>
            <div className="author">- Stakeholder Feedback on the Framework</div>
          </div>

          <div className="card">
            <div className="quote">
              “We found the application process tremendously introspective for our association, we learnt a lot about
              ourselves…”
            </div>
            <div className="author">- Stakeholder Feedback on the Framework</div>
          </div>
        </CardCarousel>
      </div>
    </section>
  );
};

export default FeedbackSection;
